module.exports = __webpack_public_path__ + "img/pocket_length.8070afa6.png";